<template>
    <div>
        <h1 style="font-size: 24px; color: black;">聊天室日报</h1>
        <el-card class="form-container" style="margin-top: 25px" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="120px">
                <el-form-item label="版本：">
                    <el-select v-model="queryData.version" multiple filterable @change="checkParam1($event)" placeholder="请选择/输入">
                        <el-option
                                v-for="item in versionList"
                                :key="item.versionCode"
                                :label="item.versionName"
                                :value="item.versionCode"
                                :disabled="item.disabled">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="聊天室名称：">
                    <el-select v-model="queryData.chatRoomIds" multiple  filterable placeholder="请选择/输入">
                        <el-option
                                v-for="item in chatRoomList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="日期：">
                    <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd">
                    </el-date-picker>&emsp;&emsp;
                </el-form-item>
                <el-form-item label="">
                    <el-button class="sub-sub9" type="primary" @click="query">查询</el-button>
                    <el-button class="sub-sub9" type="primary"  @click="exportExcel">导出</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <h1>
            <el-table
                    border
                    :data="chatReportList"
                    :header-cell-style="{background:'#282828'}"
                    ref="filterTable"
                    max-height="820">
                <el-table-column   label="日期" prop="dt" align="center"></el-table-column>
                <el-table-column   label="聊天室名称" prop="name" align="center"></el-table-column>
                <el-table-column   label="渠道名"  align="center">
                    <template slot-scope="scope" >
                        {{(scope.row.version==null ? '暂无':scope.row.version)}}
                    </template>
                </el-table-column>
                <el-table-column   label="聊天室曝光人数" prop="exUser" align="center"></el-table-column>
                <el-table-column   label="聊天室曝光人次" align="center">
                    <template slot-scope="scope" >
                        {{(scope.row.exPersonTime==null ? '0.00':scope.row.exPersonTime.toFixed(2))}}
                    </template>
                </el-table-column>
                <el-table-column   label="进入聊天室人数" prop="joinRoomUser" align="center"></el-table-column>
                <el-table-column   label="聊天室进入率"  align="center">
                    <template slot-scope="scope" >
                        {{ scope.row.joinRoomRate == null ? '0.00%' : (scope.row.joinRoomRate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>
                <el-table-column   label="发消息用户数"  prop="sendUser" align="center"></el-table-column>
                <el-table-column   label="发消息率" align="center">
                    <template slot-scope="scope" >
                        {{ scope.row.sendRate == null ? '0.00%' : (scope.row.sendRate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>
                <el-table-column   label="发关键词用户数" prop="sendKeyUser" align="center"></el-table-column>
                <el-table-column   label="发关键词率" align="center">
                    <template slot-scope="scope" >
                        {{ scope.row.sendKeyRate == null ? '0.00%' : (scope.row.sendKeyRate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>
                <el-table-column   label="消息总数"  align="center">
                    <template slot-scope="scope" >
                        {{(scope.row.totalMessage==null ? '0.00':scope.row.totalMessage)}}
                    </template>
                </el-table-column>
                <el-table-column   label="人均消息数" align="center">
                    <template slot-scope="scope" >
                        {{(scope.row.perMessage==null ? '0.00':scope.row.perMessage.toFixed(2))}}
                    </template>
                </el-table-column>
                <el-table-column   label="活跃人均消息数" align="center">
                    <template slot-scope="scope" >
                        {{(scope.row.actPerMessage==null ? '0.00':scope.row.actPerMessage.toFixed(2))}}
                    </template>
                </el-table-column>
                <el-table-column   label="新增" prop="newUser" align="center"></el-table-column>
                <el-table-column   label="次留" align="center">
                    <template slot-scope="scope" >
                        {{ scope.row.r1 == null ? '0.00%' : (scope.row.r1 * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>
                <el-table-column   label="7日留存  " align="center">
                    <template slot-scope="scope" >
                        {{ scope.row.r7 == null ? '0.00%' : (scope.row.r7 * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>
            </el-table>
        </h1>
        <div>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="[20,50,100]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {
        chatRooms,
        downloadData,
        copyList,
        searchChatReport
    } from "@/http/api";
    import utils from '@/utils'
    export default {
        name: "ChatRoomReport",
        data(){
            return{
                queryData:{
                    order:'descending',
                    prop:'dt',
                    version:[-1],
                    chatRoomIds:[-1],
                    timeDate:['',''],
                },
                page: {
                    size: 20,
                    page: 1,
                    totalElements: null
                },
                versionList:[],
                chatRoomList:[],
                chatReportList:[]
            }
        },
        methods:{
            checkParam1(val){
                let _this = this;
                if (val.indexOf(-1) > -1){
                    this.versionList.forEach(function (version) {
                        _this.$set(version,'disabled',true);
                        _this.queryData.version=[-1]
                    });
                }else {
                    this.versionList.forEach(function (version) {
                        _this.$set(version,'disabled',false);
                    });
                }
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.query();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.query();
            },
            exportExcel() {
                let fileName = new Date().toLocaleString() + '聊天室日报.xlsx';
                downloadData(
                    '/chat/exportReportExcel',
                    Object.assign(this.queryData),
                    fileName
                )
            },
            query(){
                this.queryData.page = this.page.page;
                this.queryData.size = this.page.size;
                if (this.queryData.timeDate === null) {
                    this.queryData.timeDate = ['',''];
                }
                this.queryData.startTime = this.queryData.timeDate[0] ===''?null:this.queryData.timeDate[0];
                this.queryData.endTime = this.queryData.timeDate[1]===''?null:this.queryData.timeDate[1];
                searchChatReport(this.queryData).then(resp=>{
                    this.chatReportList=resp.data.info.content;
                    this.page.totalElements =resp.data.info.totalElements;
                });
            }
        },
        created() {
            this.queryData.timeDate=[utils.TodayUtil.getToday(),utils.TodayUtil.getToday()];
            copyList().then(resp=>{
                this.versionList=resp.data.info;
                this.versionList.unshift({versionCode:-1,versionName:'全部版本'});
            });
            chatRooms().then(resp=>{
                this.chatRoomList=resp.data.info;
                this.chatRoomList.unshift({id:-1,name:'全部聊天室'});
            });
            this.query();
        }
    }
</script>

<style scoped>
    .sub-sub9{ position: relative; left: 110px}
</style>